export var CreditCardBrands;
(function (CreditCardBrands) {
    CreditCardBrands["VISA"] = "VISA";
    CreditCardBrands["MASTERCARD"] = "MASTERCARD";
})(CreditCardBrands || (CreditCardBrands = {}));
